function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon-navigation-smartphone-finger@140x140",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "streamline-icon-navigation-smartphone-finger@140x140",
  stroke: "#000",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.034 31.752l-3.87-4.354a2.18 2.18 0 113.258-2.897l2.712 3.051v-12.6a2.1 2.1 0 114.2 0v9.45h2.1a6.3 6.3 0 016.3 6.3v1.05M11.784 21.252h-9.45a2.1 2.1 0 01-2.1-2.1v-12.6c0-1.16.94-2.1 2.1-2.1",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.284 4.452h7.35c1.16 0 2.1.94 2.1 2.1v12.6a2.1 2.1 0 01-2.1 2.1h-2.1M12.309 6.552a.525.525 0 00-.525-.525M11.784 7.077c.29 0 .525-.235.525-.525M11.259 6.552c0 .29.235.525.525.525M11.784 6.027a.525.525 0 00-.525.525",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.784.252a6.3 6.3 0 016.3 6.3c0 2.69-3.763 7.808-5.473 9.993a1.05 1.05 0 01-1.654 0c-1.71-2.186-5.473-7.303-5.473-9.993a6.3 6.3 0 016.3-6.3z",
  id: "Path"
})))));